export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于51吃瓜网
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">了解吃瓜爆料第一站背后的故事</p>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="max-w-3xl">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              51吃瓜网官网创立于热爱娱乐八卦的互联网时代，致力于为吃瓜群众提供最全面、最及时的明星网红八卦资讯。
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              我们聚焦51吃瓜爆料与51吃瓜黑料两大核心板块，每日追踪全网热点人物最新动态，从娱乐圈一线明星到直播网红圈层，
              从综艺节目内幕到影视行业潜规则，51吃瓜黑料网为你揭开台前幕后的真实世界。
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
              平台采用先进的信息聚合技术，实时抓取多平台热点信号，配合专业编辑团队人工审核，
              确保每一条爆料信息真实可靠、传播有序。吃瓜不迷路，爆料看这里——这是我们不变的初心。
            </p>
            <div className="flex flex-wrap gap-6 text-sm text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500"></i> 每日更新超过100条
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500"></i> 覆盖30+内容渠道
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500"></i> 专业编辑团队审核
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}